import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractHttpService } from './http-abstract.service';
import { Person } from './dtos';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class HttpPersonService extends AbstractHttpService {
	constructor(http: HttpClient) {
        super(http);
    }

    getPersonsByCapCode(capCode: string): Observable<Person[]> {
        return super.get(`/person/${capCode}/get-by-cap-code`);
    }

}